<template>
  <div class="layout single-select">
    <div class="column">
      <h1 v-if="config.title" class="title">
        {{ $t(config.title, "options.title") }}
      </h1>
      <h1 key="question">{{ $t(config.question, "options.question") }}</h1>
    </div>
    <div :class="['column multi-select-column', columnStyle]">
      <transition-group
        appear
        name="options"
        v-on:before-appear="beforeEnter"
        tag="ul"
        class="slider-question-set"
        v-bind:css="false"
      >
        <li
          :key="`${slider.question}_${i}`"
          v-for="(slider, i) in config.sliders"
          class="slider-question-item"
        >
          <p>{{ slider.question }}</p>
          <vue-slider
            v-model="sliderValues[slider.key]"
            :min="slider.scale.low.value"
            :max="slider.scale.high.value"
            :height="15"
            :dotSize="30"
            :tooltip="'none'"
            :marks="{
              '0': slider.scale.low.legend,
              '100': slider.scale.high.legend
            }"
          ></vue-slider>
        </li>
        <li
          v-on:keyup.enter.stop="next"
          tabindex="999"
          role="button"
          :data-index="config.sliders.length"
          :style="nextButtonStyle"
          @click.stop="next"
          class="next"
          key="next"
        >
          {{ $t(buttonText, "options.buttonText") }}
        </li>
      </transition-group>
    </div>
  </div>
</template>

<script>
import Velocity from "velocity-animate";
import Vue from "vue";
import TranslationMixin from "../lib/TranslationMixin";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

export default {
  name: "SliderQuestions",
  props: ["config"],
  inject: ["convince", "theme"],
  mixins: [TranslationMixin],
  components: {
    VueSlider
  },
  data: function() {
    return {
      currentSelection: null,
      complete: false,
      sliderValues: null
    };
  },
  computed: {
    buttonText() {
      return this.config.buttonText || "Next";
    },
    columnStyle() {
      return "multi-select-columns-" + this.columnCount;
    },
    buttonStyle() {
      return {
        borderRadius: this.theme.borderRadius + "px"
      };
    },
    nextButtonStyle() {
      return Object.assign(this.theme.accent, {
        borderRadius: this.theme.borderRadius + "px"
      });
    }
  },
  methods: {
    next() {
      const scores = Object.keys(this.sliderValues).map((key) => {
        return { key: key, score: this.sliderValues[key] };
      });

      const payload = { ...this.sliderValues, _s: scores };

      this.$store.dispatch("saveAll", payload);
      this.$emit("answer");

      if (typeof this.config.next !== "undefined") {
        this.$store.commit("setIndex", this.getNext(this.config.next));
      } else {
        this.$store.commit("advance");
      }
    },
    isSelected(answer) {
      return (
        this.currentSelection && this.currentSelection.value === answer.value
      );
    },
    select(answer) {
      if (this.complete === true) {
        return;
      }
      this.complete = true;
      this.currentSelection = answer;
      let score = answer.score || 0;
      this.$store.dispatch("save", {
        key: this.config.key,
        answer: { value: this.currentSelection.value, score: score }
      });
      this.$emit("answer");
      setTimeout(this.leave, 500);
    },
    leave() {
      let answer = this.currentSelection;
      this.$gtag.event("answer", {
        event_category: "survey",
        event_label: this.config.key,
        value: this.currentSelection
      });
      if (typeof answer.next !== "undefined" && answer.next) {
        this.$store.commit("setIndex", this.getNext(answer.next));
      } else if (typeof this.config.next !== "undefined" && this.config.next) {
        this.$store.commit("setIndex", this.getNext(this.config.next));
      } else {
        this.$store.commit("advance");
      }
    },
    beforeEnter: function(el, done) {
      Velocity(
        el,
        { opacity: 0, translateY: "100%", translateZ: 0 },
        { duration: 0 }
      );
      var delay = 500 + el.dataset.index * 150;
      setTimeout(function() {
        Velocity(
          el,
          { opacity: 1, translateY: "0%", translateZ: 0 },
          { complete: done, duration: 550 }
        );
      }, delay);
    },
    addHover(i, event) {
      event.target.style.backgroundColor = this.theme.selected.backgroundColor;
      event.target.style.color = this.theme.selected.color;
      let icon = event.target.querySelector("span.icon");
      icon.classList.add("selected-icon");
      event.currentTarget.classList.add("hover");
    },
    removeHover(i, event) {
      if (event.currentTarget.classList.contains("selected")) {
        return;
      }
      event.target.style.backgroundColor = null;
      event.target.style.color = null;
      event.currentTarget.classList.remove("hover");
      let icon = event.target.querySelector("span.icon");
      icon.classList.remove("selected-icon");
    },
    mergeProperties(ob, newOb) {
      for (let prop in newOb) {
        Vue.set(ob, prop, newOb[prop]);
      }
    }
  },
  mounted() {
    this.currentSelection = null;
    window.scroll(0, 0);
  },
  created() {
    const sliderVals = {};

    for (const slider of this.config.sliders) {
      sliderVals[slider.key] = slider.scale.default;
    }

    this.sliderValues = sliderVals;
    // Vue.set(this.data, "sliderValues", sliderVals);
    if (typeof this.config.columns !== "undefined") {
      this.columnCount = this.config.columns;
    } else {
      this.columnCount = 1;
    }
  }
};
</script>

<style lang="scss">
@import "../scss/components/survey";
</style>

<style scoped lang="scss">
.slider-question-item {
  p {
    color: black;
  }
}
</style>
